import bbox from "@turf/bbox";
import type { BBox, AllGeoJSON } from "@turf/helpers";

export function getBbox(geojson: AllGeoJSON): BBox {
  if (!geojson.bbox) geojson.bbox = bbox(geojson);
  return geojson.bbox;
}
